import { createStore, compose, applyMiddleware } from 'redux';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { createBrowserHistory } from "history";
// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.
import { connectRouter, routerMiddleware } from 'connected-react-router';
import createRootReducer from '../reducers';

export const history = createBrowserHistory();
const connectRouterHistory = connectRouter(history);
function saveToLocalStorage(state) {
    try {
        const serilizedState = JSON.stringify(state)
        localStorage.setItem('state', serilizedState)
    } catch (e) {
        console.log(e)
    }

}

function loadFromLocalStorage(initialState) {
    try {
        const serilizedState = localStorage.getItem('state')
        if (serilizedState === null) return initialState
        return JSON.parse(serilizedState)
    }
    catch (e) {
        console.log(e)
        return initialState
    }
}

function configureStoreProd(initialState) {
    const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [
        // Add other middleware on this line...

        // thunk middleware can also accept an extra argument to be passed to each thunk action
        // https://github.com/reduxjs/redux-thunk#injecting-a-custom-argument
        thunk,
        reactRouterMiddleware,
    ];
    const persistedState = loadFromLocalStorage(initialState)
    const store = createStore(
        createRootReducer(history), // root reducer with router state
        persistedState,
        compose(applyMiddleware(...middlewares))
    );
    store.subscribe(() => saveToLocalStorage(store.getState()))

    return store;
}

function configureStoreDev(initialState) {
    const reactRouterMiddleware = routerMiddleware(history);
    const middlewares = [
        // Add other middleware on this line...

        // Redux middleware that spits an error on you when you try to mutate your state either inside a dispatch or between dispatches.
        reduxImmutableStateInvariant(),

        // thunk middleware can also accept an extra argument to be passed to each thunk action
        // https://github.com/reduxjs/redux-thunk#injecting-a-custom-argument
        thunk,
        reactRouterMiddleware,
    ];

    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
    const persistedState = loadFromLocalStorage(initialState)
    const store = createStore(
        createRootReducer(history), // root reducer with router state
        persistedState,
        composeEnhancers(applyMiddleware(...middlewares))
    );

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('../reducers', () => {
            const nextRootReducer = require('../reducers').default; // eslint-disable-line global-require
            store.replaceReducer(connectRouterHistory(nextRootReducer));
        });
    }
    store.subscribe(() => saveToLocalStorage(store.getState()))

    return store;
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
